import React from 'react';
import { cx } from './classNames';
import './ui-layout.css';

export interface PageHeaderProps {
  title: React.ReactNode;
  /** 題の上に置く小さな文字（「マスタ管理」など）。Phase 2 まではリンクにしない */
  eyebrow?: React.ReactNode;
  /** 題の下の 1 行説明 */
  subtitle?: React.ReactNode;
  /** 題の左に置く lucide アイコン */
  icon?: React.ReactNode;
  /** 題の右に添えるバッジ（状態など） */
  badge?: React.ReactNode;
  /** 右端の操作群 */
  actions?: React.ReactNode;
  /** 下段。Tabs をそのまま差し込む想定 */
  tabs?: React.ReactNode;
  className?: string;
}

/** ページヘッダ（4 パターンのひとつ）。全画面で同じ形にするための入れ物 */
export function PageHeader({
  title,
  eyebrow,
  subtitle,
  icon,
  badge,
  actions,
  tabs,
  className,
}: PageHeaderProps) {
  return (
    <header className={cx('ui-pageheader', className)}>
      <div className="ui-pageheader__top">
        <div className="ui-pageheader__heading">
          {eyebrow != null && <div className="ui-pageheader__eyebrow">{eyebrow}</div>}
          <div className="ui-pageheader__titlerow">
            {icon && (
              <span className="ui-pageheader__icon" aria-hidden="true">
                {icon}
              </span>
            )}
            <h1 className="ui-pageheader__title">{title}</h1>
            {badge != null && <span className="ui-pageheader__badge">{badge}</span>}
          </div>
          {subtitle != null && <p className="ui-pageheader__subtitle">{subtitle}</p>}
        </div>
        {actions != null && <div className="ui-pageheader__actions">{actions}</div>}
      </div>
      {tabs != null && <div className="ui-pageheader__tabs">{tabs}</div>}
    </header>
  );
}
